import { useVirtualizer } from "@tanstack/react-virtual";
import * as React from "react";
import { Box } from "@chakra-ui/react";
import { CSRDReportAnswers } from "./index";

function CSRDReportVirtualizedList({ items }) {
  const parentRef = React.useRef(null);

  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 900,
    enabled: true
  });

  const virtualItems = virtualizer.getVirtualItems();

  return (
    <>
      <Box
        ref={parentRef}
        style={{
          height: 1000,
          overflowY: "auto",
          contain: "strict"
        }}
      >
        <Box
          style={{
            height: virtualizer.getTotalSize(),
            width: "100%",
            position: "relative"
          }}
        >
          <Box
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              transform: `translateY(${virtualItems[0]?.start ?? 0}px)`
            }}
          >
            {virtualItems.map((virtualRow) => (
              <Box
                key={virtualRow.key}
                data-index={virtualRow.index}
                ref={virtualizer.measureElement}
              >
                <CSRDReportAnswers questionObj={items[virtualRow.index]} questionIndex={virtualRow.index} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default CSRDReportVirtualizedList;